const RELEASE_COLORS: Record<string, { dot: string; text: string }> = {
	alpha: { dot: "bg-amber-500", text: "text-amber-500" },
	beta: { dot: "bg-emerald-500", text: "text-emerald-500" },
};

const ENV_COLORS: Record<string, string> = {
	dev: "bg-amber-500",
	preview: "bg-purple-500",
	local: "bg-gray-500",
};

export function ReleaseBadge() {
	const releaseVersion = import.meta.env.VITE_RELEASE_VERSION || "";
	const environment = import.meta.env.VITE_ENVIRONMENT || "local";

	const showRelease =
		releaseVersion === "alpha" || releaseVersion === "beta";
	const showEnv = environment !== "production";

	if (!showRelease && !showEnv) return null;

	const colors = RELEASE_COLORS[releaseVersion];
	const envColor = ENV_COLORS[environment] || "bg-gray-500";

	return (
		<span className="inline-flex flex-wrap items-center gap-1 ml-2">
			{showRelease && colors && (
				<span
					className={`inline-flex items-center gap-1 text-[10px] font-semibold ${colors.text}`}
				>
					<span
						className={`w-1.5 h-1.5 rounded-full ${colors.dot} animate-pulse`}
					/>
					{releaseVersion}
				</span>
			)}
			{showEnv && (
				<span
					className={`text-[9px] font-bold text-white px-1.5 py-px rounded-lg uppercase tracking-wide ${envColor}`}
				>
					{environment}
				</span>
			)}
		</span>
	);
}
